import { z } from "zod";

export const addressUpsertValidator = z.object({
  address_line_1: z
    .string({ error: "Address is required" })
    .min(1, "Address is required"),
  address_line_2: z.string().optional(),
  city: z.string({ error: "City is required" }).min(1, "City is required"),
  state: z.string({ error: "State is required" }).min(1, "State is required"),
  country: z
    .string({ error: "Country is required" })
    .min(1, "Country is required"),
  postcode: z
    .string({ error: "Postcode is required" })
    .min(1, "Postcode is required"),
});

export const addressValidator = z.object({
  upsert: addressUpsertValidator,
});
